import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoIcon from '../components/assets/icon.png';
import Footer from '../components/Footer';
import EnquiryModal from '../components/EnquiryModal';
import '../App.css';

const DigitalContent = () => {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="service-page">
      {/* Header */}
      <nav className="navbar scrolled">
        <div className="container nav-content">
          <Link to="/" className="logo">
            <img src={logoIcon} alt="Magic Moon Studios" className="logo-icon-img" />
            <span className="logo-text">MAGIC MOON STUDIOS</span>
          </Link>

          <button 
            className="mobile-menu-btn" 
            onClick={(e) => {
              e.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
              setIsDropdownOpen(false);
              document.body.style.overflow = isMenuOpen ? 'unset' : 'hidden';
            }}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          {isMenuOpen && (
            <div 
              className="mobile-menu-backdrop" 
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(false);
                setIsDropdownOpen(false);
                document.body.style.overflow = 'unset';
              }}
            />
          )}

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={handleMenuClick}>Home</Link></li>
            <li><a href="/#about" onClick={handleMenuClick}>About</a></li>
            <li><a href="/#projects" onClick={handleMenuClick}>Projects</a></li>
            <li className={`dropdown ${isDropdownOpen ? 'active' : ''}`}>
              <a href="#services" onClick={toggleDropdown}>Services ▾</a>
              <ul className="dropdown-menu">
                <li><Link to="/film-production" onClick={handleMenuClick}>Film Production</Link></li>
                <li><Link to="/short-movies" onClick={handleMenuClick}>Short Movies</Link></li>
                <li><Link to="/academy" onClick={handleMenuClick}>Academy</Link></li>
                <li><Link to="/ads-making" onClick={handleMenuClick}>Ads Making</Link></li>
                <li><Link to="/digital-content" onClick={handleMenuClick}>Digital Content</Link></li>
                <li><Link to="/music-production" onClick={handleMenuClick}>Music Production</Link></li>
              </ul>
            </li>
            <li><a href="/#team" onClick={handleMenuClick}>Team</a></li>
            <li><a href="/#contact" className="contact-btn" onClick={handleMenuClick}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="service-hero" style={{ 
        background: 'linear-gradient(rgba(15, 52, 96, 0.85), rgba(26, 26, 46, 0.85)), url("https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=2000&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container">
          <div className="service-hero-content">
            <h1 className="service-hero-title">Digital Content</h1>
            <p className="service-hero-subtitle">
              Web series, commercials, and social media content creation
            </p>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2 style={{ color: '#5B9BD5', marginBottom: '20px' }}>Digital-First Content Creation</h2>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Magic Moon Studios creates engaging digital-first content optimized for online platforms and social media. 
                From viral short-form videos to episodic web series, we understand the unique dynamics of digital audiences 
                and craft content that captures attention in crowded social feeds.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Our digital content services encompass YouTube videos, Instagram Reels, TikTok content, podcast videos, 
                and streaming platform originals. We combine creative storytelling with data-driven insights to maximize 
                reach, engagement, and shareability across all major social platforms.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Whether you need daily content for social media, weekly YouTube episodes, or premium web series, 
                our team delivers platform-specific content that aligns with algorithm preferences, trending formats, 
                and audience behavior patterns to ensure maximum visibility and viral potential.
              </p>
            </div>
            <div className="overview-image">
              <img 
                src="https://images.unsplash.com/photo-1611162616305-c69b3fa7fbe0?q=80&w=800&auto=format&fit=crop" 
                alt="Digital Content Creation"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '15px',
                  border: '3px solid #B8860B',
                  boxShadow: '0 10px 30px rgba(184, 134, 11, 0.3)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services We Offer */}
      <section className="service-offerings" style={{ background: 'linear-gradient(to bottom, #F0F9FF 0%, #E3F2FD 100%)', padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#5B9BD5', marginBottom: '50px', fontSize: '2.5rem' }}>What We Offer</h2>
          <div className="offerings-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {[
              { 
                title: 'YouTube Content', 
                desc: 'Long-form videos, vlogs, documentaries, and episodic series optimized for YouTube algorithm and viewer retention', 
                icon: '▶️' 
              },
              { 
                title: 'Instagram Reels', 
                desc: 'Vertical short-form videos designed for maximum engagement with trending audio, effects, and viral storytelling techniques', 
                icon: '📸' 
              },
              { 
                title: 'TikTok Videos', 
                desc: 'Creative, trend-driven content that leverages platform features, challenges, and viral formats to build massive reach', 
                icon: '🎶' 
              },
              { 
                title: 'Podcast Videos', 
                desc: 'Video podcast production with multi-camera setups, dynamic editing, and platform distribution for Spotify and YouTube', 
                icon: '🎙️' 
              }
            ].map((service, index) => (
              <div key={index} style={{
                background: '#fff',
                padding: '30px',
                borderRadius: '15px',
                border: '2px solid #B8860B',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                boxShadow: '0 5px 20px rgba(91, 155, 213, 0.15)'
              }}>
                <div style={{ fontSize: '4rem', marginBottom: '15px' }}>{service.icon}</div>
                <h3 style={{ color: '#FFD700', marginBottom: '10px' }}>{service.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta" style={{ 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', 
        padding: '80px 0',
        textAlign: 'center',
        color: '#fff'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#FFD700' }}>Ready to Go Viral?</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', color: '#87CEEB' }}>
            Let's create digital content that captures attention and builds your online presence
          </p>
          <button onClick={() => setIsEnquiryOpen(true)} style={{
            display: 'inline-block',
            padding: '15px 40px',
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            color: '#1a1a2e',
            borderRadius: '30px',
            fontWeight: '700',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem',
            transition: 'transform 0.3s ease'
          }}>
            Get Started
          </button>
        </div>
      </section>

      {/* Enquiry Modal */}
      <EnquiryModal 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
        serviceName="Digital Content Creation"
      />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default DigitalContent;
